import React from 'react';
import styled from 'styled-components';
import { PictureWithSources } from '../../common/PictureWithSources';
import { IeBenefitType } from '../../../types/entities';
import { breakpoints } from '../../../utils/styles';

const BenefitsContainer = styled.div<{ visible: boolean }>`
    background: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    bottom: 0;
    height: 98%;
    left: 0;
    overflow: auto;
    padding: 3em;
    position: fixed;
    text-align: center;
    transform: translateY(${props => props.visible ? `0` : `100%`});
    transition: all 0.5s;
    width: 100%;
    z-index: 1050;

    & > header {
        color: #555;
        font-size: 0.85em;
        line-height: 1.5em;
        margin-bottom: 3em;

        & > i { font-size: 3em; margin-bottom: 0.5em; }
    }

    body.theme-market & {
        background: var(--page-bg);
    }

    body.theme-platinum & {
        background: var(--primary-b);
        ${props => props.visible && 'box-shadow: 0 0 50px rgba(0,0,0,0.85);'}

        & > header {
            color: #FFFFFF;
        }
    }
`;

const CloseCross = styled.button`
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    background: none;
    border: none;
    outline: none;
    font-size: 1.5em;
    color: var(--text-color);

    &:focus { outline: none; }
`;

const BenefitsBoxTitle = styled.h3`
    color: var(--text-primary);
    font-family: var(--ff-subtitle);
    font-size ${30/12.6}rem;

    body.theme-market &,
    body.theme-platinum & {
        color: var(--primary);
        font-weight: 700;
    }
`;

const BenefitsList = styled.ul`
    list-style-type: none;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5%;

    @media screen and (min-width: ${breakpoints.tablet}px) {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 1em;
    }
`;

const BenefitItem = styled.li`
    cursor: pointer;
    & img {
        position: relative;
        width: 100%;
        z-index: 2;
    }
`;

interface Props {
    visible: boolean;
    onClose: () => void;
    onBenefitClick: (benefit: IeBenefitType) => void;
    benefits: IeBenefitType[];
    levelName: string;
    levelColor: string;
    levelType: string;
}

class BenefitsListComponent extends React.Component<Props> {    
    render() {
        const { 
            visible,
            onClose,
            onBenefitClick,
            benefits,
            levelName,
            levelColor
        } = this.props;
        
        return (
            <BenefitsContainer visible={visible}>
                <CloseCross onClick={onClose}><i className="fal fa-times"></i></CloseCross>
                <header>
                    <BenefitsBoxTitle>Beneficios Cinemex Loop {levelName}</BenefitsBoxTitle>
                </header>
                <BenefitsList>
                    {benefits.map((benefit, index) => (
                        <BenefitItem 
                            key={index}
                            color={levelColor}
                            onClick={() => onBenefitClick(benefit)}
                        >
                            <PictureWithSources
                                images={benefit.images && benefit.images.thumb ? benefit.images.thumb : undefined}
                                fallback={benefit.thumb}
                                title={benefit.title}
                            />
                        </BenefitItem>
                    ))}
                </BenefitsList>
            </BenefitsContainer>
        );
    }
}

export {
    BenefitsContainer,
    BenefitsList,
    BenefitItem
};

export default BenefitsListComponent;
